import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_DEPENDENTS } from '../graphql/profile/queries/get-dependents';
import { DependentProfile } from '../graphql/profile/models/kids.models';

export const useDependentColors = () => {
  const { data } = useQuery(GET_DEPENDENTS, { fetchPolicy: 'cache-first' });

  const dependentColorMap = useMemo(() => {
    const map = new Map<string, number>();

    if (data?.getDependents) {
      const allKids = data.getDependents;
      allKids.forEach((kid: DependentProfile, index: number) => {
        const key = `${kid.firstName}-${kid.lastName}`;
        const colorIndex = index + 1;
        map.set(key, colorIndex);
      });
    }

    return map;
  }, [data]);

  const getDependentColorIndex = (firstName: string, lastName: string): number | undefined => {
    return dependentColorMap.get(`${firstName}-${lastName}`);
  };

  return { getDependentColorIndex, dependentColorMap };
};